import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Archived.css';
import Icon from '../../components/UI/Icon/Icon';
import Route from '../Route/Route';
import Request from '../Request/Request';
import TripModal from '../../components/TripModal/TripModal';
import RequestModal from '../../components/RequestModal/RequestModal';
import Button from '../../components/UI/Button/Button';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import * as actionTypes from '../../store/actions';
import logError from '../../store/LogError';
import axios from '../../axios-trips';
import Modal from '../../components/UI/Modal/Modal';

class Archived extends Component {

  state = {
    archived: [],
    pagination: 10,
    hasMore: true
  }

  componentDidMount() {
    if (this.props.access_token) {
      this.retrieveArchived();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.access_token && this.props.access_token) {
      this.retrieveArchived();
    }

    if (prevState.archived.length !== this.state.archived.length) {
      this.getRequests();
      this.setState({ hasMore: false });
      setTimeout(() => this.setState({ archived: this.state.archived, hasMore: true }), 1000);
    }
  }

  getRequests = async () => {
    const updatedArchived = [...this.state.archived];
    await updatedArchived.forEach(async arch => {
      if (!arch.requests) {
        await this.findRequests(arch)
          .then(response => {
            arch.requests = response.data;
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              logError(
                this.props.access_token,
                this.props.codeToMessage[error.response.status],
                '/api/v1/trips/archived'
              );
              this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
            }
          });
      }
    });
    this.setState({ archived: [...updatedArchived] });
  }

  findRequests = async (arch) => {
    return await axios({
      method: 'get',
      url: `/api/v1/requests/trip?tripId=${arch.id}`,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    });
  }

  retrieveArchived = () => {
    axios({
      method: 'get',
      url: `/api/v1/trips/archived?limit=${this.state.pagination}`,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      const oldData = [...this.state.archived];
      const updatedData = [];
      response.data.forEach(arch => {
        let found = false;
        for (let i = 0; i < oldData.length; i++) {
          if (oldData[i].id === arch.id) {
            found = true;
            break;
          }
        }
        arch.origin = 0;
        arch.destination = arch.tripPoints.length - 1;
        if (!found) {
          updatedData.push(arch);
        }
      });

      if (updatedData.length === 0) {
        this.setState({ hasMore: false });
      }
      this.setState(
        {
          archived: [...this.state.archived, ...updatedData],
          pagination: this.state.pagination + 10
        });
    })
    .catch(error => {
      console.log(error);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/trips/archived'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  changeRouteHandler = (updatedRoute, row, column) => {
    try {
      const updatedRoutes = this.props.routes;
      let index = -1;
      for (let i = 0; i < updatedRoutes.length; i++) {
        if (updatedRoutes[i].id === updatedRoute.id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        updatedRoutes[index] = updatedRoute;
        this.props.onSetRoutes(updatedRoutes);
      }
    } catch (err) {
      console.log("Error when updating route: " + err);
    }
  }

  render() {
    return (
      <Aux>
        <TripModal
          closeCard={() => this.props.onSelectTrip(null)}
          card={this.props.selectedTrip}
          changeRouteHandler={this.changeRouteHandler} />
        <RequestModal
          closeCard={() => this.props.onSelectRequest(null)}
          card={this.props.selectedRequest} />
        <div className={classes.Archived}>
          {
            this.state.archived.map(route => {
              console.log("Route requests: ", route.requests);
              return (
                <Route
                  key={"T" + route.id}
                  id={"T" + route.id}
                  type={route.type}
                  archived={route.archived}
                  origin={route.origin}
                  destination={route.destination}
                  tripDate={route.tripDate}
                  capacity={route.capacity}
                  priority={route.priority}
                  price={route.price}
                  priceComment={route.priceComment}
                  priceConfirmed={route.priceConfirmed}
                  carrierId={route.carrier}
                  carrierOkpo={route.carrierOkpo}
                  carrierPartner={route.carrierPartner}
                  carrierName={route.carrierName}
                  carrierLs={route.carrierLs}
                  carrierConfirmed={route.carrierConfirmed}
                  driver={route.driver}
                  car={route.car}
                  managers={route.managers}
                  dispatcher={route.dispatcher}
                  car={route.car}
                  note={route.note}
                  tripPoints={route.tripPoints}
                  setTripHandler={(card) => this.props.onSelectTrip(card)}
                  requests={route.requests ? route.requests : []}
                  setRequestHandler={(card) => this.props.onSelectRequest(card)}
                  from={null}
                  to={null} />
              )
            })
          }

          <Button
            btnType='Success'
            disabled={!this.state.hasMore}
            clicked={(ev) => this.retrieveArchived()}>ЗАГРУЗИТЬ БОЛЬШЕ</Button>
        </div>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    codeToMessage: state.codeToMessage,
    selectedTrip: state.selectedTrip,
    selectedRequest: state.selectedRequest
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    onSelectTrip: (selectedTrip) => dispatch({ type: actionTypes.SELECT_TRIP,
                                               selectedTrip: selectedTrip}),
    onSelectRequest: (selectedRequest) => dispatch({ type: actionTypes.SELECT_REQUEST, selectedRequest: selectedRequest})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Archived);



// WEBPACK FOOTER //
// ./src/containers/Archived/Archived.js